module.exports = __webpack_public_path__ + "img/icon_up_result_pop__002.70eba0ed.png";